import { useEffect, useState } from 'react';
import { router, usePage } from '@inertiajs/react';
import AppShell from '../../../components/layout/AppShell';
import VisitHistoryList from '../../../components/sentence_studio/VisitHistoryList';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';

export default function StudentSentenceStudioIndex({ visits = [] }) {
  const { auth } = usePage().props;
  const { clear } = useBreadcrumbs();
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { clear(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function submit(e) {
    e.preventDefault();
    if (!text.trim() || submitting) return;
    setSubmitting(true);
    router.post('/student/sentence_studio',
      { text: text.trim() },
      { onFinish: () => setSubmitting(false) }
    );
  }

  return (
    <AppShell student={auth?.user} scrollTitle="Sentence Studio">
      <div className="max-w-3xl mx-auto space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Sentence Studio</h1>
          <p className="mt-2 text-gray-500 dark:text-gray-400">
            Analyze a sentence — yours or one from a book — and see how it's built.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Paste a sentence
          </label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={3}
            className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="She set the lantern on the stone wall and listened for footsteps."
          />
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={!text.trim() || submitting}
              className="px-4 py-2 text-sm font-medium rounded-lg bg-gray-900 text-white dark:bg-white dark:text-gray-900 disabled:opacity-40"
            >
              {submitting ? 'Analyzing…' : 'Analyze'}
            </button>
          </div>
        </form>

        <div>
          <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
            History
          </h2>
          <VisitHistoryList
            visits={visits}
            basePath="/student/sentence_studio"
            showAuthor
          />
        </div>
      </div>
    </AppShell>
  );
}
